import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  main: {
    height: "calc(100vh - 475px)",
  },
  root: {
    font: "inherit",
    height: "calc(100vh - 591px)",
    overflowY: "auto",
    position: "relative",
  },
  notesGrid: {
    height: "auto",
    backgroundColor: "#F2F3F4",
    padding: "15px",
    marginBottom: "5px",
    borderRadius: "10px",
  },
  notes: {
    display: "flex",
    wordWrap: "break-word",
    alignItems: "center",
  },
  noteLine: {
    whiteSpace: "pre-line",
  },
}));
